module.exports = __webpack_public_path__ + "static/img/customer-case-bg.c77534c0.png";